import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=8bff5392"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ConfigPage.vue?vue&type=style&index=0&id=8bff5392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports